export function Countdown({ msLeft }: { msLeft: number }) {
  const total = Math.max(0, Math.floor(msLeft / 1000));
  const mm = String(Math.floor(total / 60)).padStart(2, '0');
  const ss = String(total % 60).padStart(2, '0');
  const color = total <= 10 ? 'text-red-400' : 'text-white';
  return (
    <div className={`font-mono text-2xl tabular-nums ${color}`}>
      {mm}:{ss}
    </div>
  );
}
